// extracted by mini-css-extract-plugin
module.exports = {"root":"TaxesTemplate_root__VHb3K","buttonContainer":"TaxesTemplate_buttonContainer__eaRUB","rotation":"TaxesTemplate_rotation__cLAEs"};